import React from 'react';
import { useSelector } from 'react-redux';

import { State } from 'shared/store/types';
import { VISITOR_PRIORITIZATION_FALLBACK_IMAGE } from 'shared/constants/visitorPrioritization';
import Loadable from './Loadable';

const VisitorPrioritizationPage: React.FC = () => {
  const { visitorPrioritization } = useSelector(
    (state: State) => state.remoteConfig.configs
  );

  const imageUrl =
    visitorPrioritization?.imageUrl || VISITOR_PRIORITIZATION_FALLBACK_IMAGE;

  return <Loadable imageUrl={imageUrl} />;
};

export default VisitorPrioritizationPage;
